<template>
    <div class="comp-header-dc comp">
        <div class="header-top">
            <div class="header-top-container">
                <div>
                    <span v-if="$cache.getCompanyInfoParam('10101009')">客服热线：</span>
                    <span v-if="$cache.getCompanyInfoParam('10101009')">
                        {{ $cache.getCompanyInfoParam("10101009") }}
                    </span>

                    <a
                        v-for="(item, index) in linkData"
                        :key="index"
                        :class="{ line: index > 0 }"
                        :href="item.address"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {{ item.name }}
                    </a>
                </div>
                <div class="flex">
                    <span v-if="login">
                        {{
                            info.custname
                                ? info.custname
                                : info.mobile
                                ? info.mobile
                                : info.mobileno
                        }}
                    </span>
                    <!-- <span v-if="login" class="line">
                        积分：{{ otherInfo.lucre ? parseFloat(otherInfo.lucre).toFixed(2) : 0 }}
                    </span> -->
                    <span v-if="info.risklevel && login" class="line">
                        风险承受能力：{{ $cache.getDict("100017", info.risklevel) }}
                    </span>
                    <span v-if="login" class="line">
                        预留信息:
                        <span
                            style="color: var(--color-1479d7); cursor: pointer"
                            v-on:click="toModifyRemark"
                        >
                            {{ info.remark || "未设置" }}
                        </span>
                    </span>
                    <span v-if="login" class="logoff cursor line" v-on:click.prevent="logoff">
                        <img :src="require('../../assets/img/logoff.png')" />
                        <span>[安全退出]</span>
                    </span>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="header-box">
                <div class="logo">
                    <img
                        v-if="$cache.getCompanyInfoParam('10101007')"
                        :src="
                            $util.imgSrc({
                                fileCode: $cache.getCompanyInfoParam('10101007')
                            })
                        "
                        height="36"
                        alt=""
                        v-on:click.prevent="goLogin"
                    />
                    <span v-if="tit" class="tit">{{ tit }}</span>
                </div>
                <ul v-if="!login" class="links">
                    <slot></slot>
                </ul>
                <div v-else class="menu right">
                    <menu-con v-if="!menuHidden" />
                </div>
            </div>
        </div>
        <remark-dialog
            :visible="remarkShow"
            :current-remark="info.remark"
            v-on:close="remarkShow = false"
            v-on:success="handleRemarkSuccess"
        />
    </div>
</template>
<script>
import userApi from "@/api/user";
import menuCon from "@/components/frame/menu.vue";
import RemarkDialog from "@/components/acctInfo/remarkDialog.vue";
import { clearUrlQuery } from "@/util/url.js";
export default {
    name: "HeaderComDc",
    components: {
        menuCon,
        RemarkDialog
    },
    props: {
        tit: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            info: {},
            otherInfo: {},
            login: false,
            menuHidden: false,
            remarkShow: false,
            linkData: [] // 顶部栏展示链接
        };
    },
    watch: {
        "$store.state.user.info"() {
            this.info = this.$cache.getUser();
        }
    },
    mounted() {
        this.info = this.$cache.getUser();
        document.title = this.$cache.getCompanyInfoParam("10101001") || this.$route.meta.nameText;
        this.linkData = this.$cache.getCompanyInfoParam("10105007")
            ? JSON.parse(this.$cache.getCompanyInfoParam("10105007"))
            : [];
        this.login = this.$store.state.login.status;
        this.menuHidden = this.$route.meta.menuHidden;
        this.qryCrmCustInfo();
    },
    methods: {
        async qryCrmCustInfo() {
            const otherUserInfo = this.$cache.getUserOtherInfo();
            if (otherUserInfo && otherUserInfo.custnoCrm && otherUserInfo.isbind == "0") {
                const res = await userApi.qryCrmCustInfo({
                    custnoCrm: otherUserInfo.custnoCrm
                });
                // 纯代销客户刷新用户信息缓存
                this.$cache.setUser(Object.assign({}, this.$cache.getUserOtherInfo(), res.data));
                this.otherInfo = res.data;
            }
        },
        async logoff() {
            const _this = this;
            this.$confirm("您确定退出吗？", "温馨提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: ""
            }).then(async () => {
                const res = await userApi.logout();
                if (res.error) return;
                _this.$store.dispatch("logout", res.data).then(() => {
                    clearUrlQuery(["code"]);
                    _this.$router.replace("/");
                });
            });
        },
        goLogin() {
            clearUrlQuery(["code"]);
            this.$router.push({ name: "login" });
        },
        toModifyRemark() {
            // 预留信息修改不再跳账户安全，避免纯代销用户通过头部入口进入受限页面。
            this.remarkShow = true;
        },
        handleRemarkSuccess(info) {
            this.info = info;
        }
    }
};
</script>
<style lang="scss" scoped>
.comp-header-dc {
    background-color: $bg2;
    min-width: 1200px;
    border-bottom: 3px solid var(--color-primary);
    .header-top {
        background: $bg1;
        font-size: 14px;
        color: $text-color1;
        .header-top-container {
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 1200px;
            margin: 0 auto;
        }
        .service,
        .logoff {
            color: $bg18;
            display: flex;
            align-items: center;
            img {
                width: 16px;
                height: 16px;
                margin-right: 6px;
            }
        }
        .logoff img {
            width: 13.5px;
            height: 13.5px;
        }
        span {
            display: inline-block;
        }
        .line {
            position: relative;
            &:before {
                content: "";
                height: 17px;
                margin: 0 10px;
                border-left: 1px solid #666666;
            }
        }
    }
    .container {
        position: relative;
        height: 100%;
        .header-box {
            height: 80px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .logo {
            margin-top: 0;
            display: inline-block;
            display: flex;
            align-items: center;
            .tit {
                display: inline-block;
                color: $text-color2;
                font-size: $f22;
                min-width: 200px;
                font-weight: 500;
            }
            .tit:before {
                content: "";
                margin: 0 24px 0 34px;
                border-left: 1px solid #ccc;
            }
            img {
                vertical-align: middle;
                height: 36px;
            }
        }
        .menu {
            outline: none;
        }
        .links {
            font-size: 14px;
            color: $text-color1;
            li {
                display: inline-block;
                margin-left: 12px;
            }
        }
    }
    .hoverCursor {
        &:hover {
            cursor: pointer;
            color: red;
        }
    }
}
</style>
